module.exports = __webpack_public_path__ + "static/media/mopping.25bfc4b8.png";